import { styled } from '@mui/system';
import { AccordionDetails, AccordionSummary, Avatar, Typography } from '@mui/material';

export const PanelSummary = styled(AccordionSummary)(() => ({
  '& > div': {
    alignItems: 'center',
    justifyContent: 'space-between'
  }
}));

export const TitleContainer = styled('div')(() => ({
  display: 'flex'
}));

export const StyledAvatar = styled(Avatar)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  width: 24,
  height: 24,
  fontSize: 'small'
}));

export const StyledTitle = styled(Typography)(({ theme }) => ({
  marginLeft: theme.spacing(1)
}));

export const PanelDetails = styled(AccordionDetails)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gridGap: theme.spacing(2)
}));
